<template >
  <!-- About Start -->
    <section id="about" class="about" >
      <div class="about-decor">
        <div class="about-circle1"><img :src='"../assets/images/team1.png"' alt="team1"></div>
        <div class="about-circle2"><img :src='"../assets/images/main-banner1.png"' alt="banner1"></div>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-md-5">
            <div class="about-contain">
              <div>
                <h2 class="title">Hire <span>Stoked Skills</span></h2>
                <p class="caption-about">Stoked Skills is a firm believer in Voice-first technology and has the expertise to bring your ideas to life. Hire us to help you design, build, and deploy your next voice first project. </p>
                <div class="row sm-mb">
                  <div class="col-6">
                    <ul class="about-style">
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon1.png"' alt="Proven-Track-Record">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Proven Track-Record</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon3.png"' alt="Great-VUI-Design">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Great VUI Design</h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="col-6">
                    <ul class="about-style">
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon2.png"' alt="Expand-your-reach">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Expand your reach</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon4.png"' alt="Early-Adopter">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Be an early adopter</h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="top-margin">
                    Reach out to us at <a href="mailto:contact@stokedskills.com" class="theme-color"> contact@stokedskills.com </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 d-medium-none">
            <div class="about-right">
              <div class="about-phone">
                <img  :src='"../assets/images/echospot2.png"' class="img-fluid" alt="aboutus">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- About End -->

</template>
<script>
export default {
  name: 'about'
}
</script>



// WEBPACK FOOTER //
// src/components/about.vue